import classNames from "classnames";
import { Popover } from "antd";
import { NOTE_STATUS, type Note, type Person } from "@/services/api";
import { CircleIcon } from "@/shared/icons";
import type { FC } from "react";
import styles from "../styles.module.scss";
import { getCircleColor } from "../../../utils";
import { CalendarEventTooltip } from "../calendar-event-tooltip";

type CalendarEventNoteContentProps = {
  note: Note | null | undefined;
  person?: Person | null | undefined;
};

const alignConfig = {
  points: ["bl", "tr"],
  overflow: {
    adjustX: true,
    adjustY: true,
  },
  offset: [-10, 20],
  dynamicInset: true,
};

export const CalendarEventNoteContent: FC<CalendarEventNoteContentProps> = ({ note, person }) => {
  return (
    // TODO: Move to styles
    <div style={{ width: "100%", height: "100%" }}>
      <Popover
        overlayClassName={styles.popover}
        align={alignConfig}
        arrow={false}
        content={
          <CalendarEventTooltip
            person={person}
            title={note?.title || ""}
            describe={note?.text || ""}
            note={note}
          />
        }
      >
        <div className={styles["flex-container"]}>
          <CircleIcon className={styles[`circle-${getCircleColor(note)}`]} />
          <span
            className={classNames(styles["todo-text"], {
              [styles.crossed]: note?.status === NOTE_STATUS.DONE,
            })}
          >
            {note?.title}
          </span>
        </div>
      </Popover>
    </div>
  );
};
